import React, { useEffect, useState } from 'react';
import { Bounce } from 'react-activity';
import { Backdrop } from '@mui/material';
import 'react-activity/dist/Bounce.css';

function Loader({ loading }) {
  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, display: 'flex', flexDirection: 'column' }}
        open={loading}
      >
      {loading ? (
        <div
          style={{
            display: 'flex',
            height: '60vh',
            width:'100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            // background:'gray'
          }}
        >
          <Bounce color="#1976D2" size={50} speed={1} animating={true} />{' '}
        </div>
        
      ) : (
        <></>
      )}
      </Backdrop>
    </div>
  );
}

export default Loader



